import { render, staticRenderFns } from "./AddictiveStuffClientDiseasesEdit.vue?vue&type=template&id=7650044c&scoped=true&"
import script from "./AddictiveStuffClientDiseasesEdit.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientDiseasesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7650044c",
  null
  
)

export default component.exports